module.exports = __webpack_public_path__ + "img/home2.6d1e1f76.png";